// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__y6519 {
  display: flex;
  justify-content: center;
}

.styles_header__responsivContent__PdP\\+W {
  display: flex;
  align-items: center;
  width: 100%;
}

.styles_content__responsivContent__YzOKE {
  margin-top: 2rem;
  width: 100%;
}

.styles_icon__header__nFZx- {
  color: #18316e;
  font-size: 2rem;
}

.styles_title__header__1kkBV {
  font-family: Abhaya Libre;
  color: #18316e;
  font-size: 2rem;
  margin-left: 1rem;
}

.styles_title__content__EyjJH {
  font-size: 1rem !important;
  font-weight: 600;
  text-align: left;
  font-family: Inter;
}

.styles_text__content__o5qED {
    margin-top: 1rem;
    color: #18316e;
    font-family: Inter;
    font-weight: 400;
}

.styles_container__campos__C4\\+tD{
  margin-top: 1rem;
  max-height: 30vh;
  overflow: auto;
}

.styles_container__buttons__waFi8{
  display: flex;
  justify-content: flex-end;
  margin-top: 1rem;
  width: 100%;
}

.styles_form__O10P1{
  margin-top: 1rem;
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/pages/EditarDadosCandidato/styles.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb","sourcesContent":[".container {\n  display: flex;\n  justify-content: center;\n}\n\n.header__responsivContent {\n  display: flex;\n  align-items: center;\n  width: 100%;\n}\n\n.content__responsivContent {\n  margin-top: 2rem;\n  width: 100%;\n}\n\n.icon__header {\n  color: #18316e;\n  font-size: 2rem;\n}\n\n.title__header {\n  font-family: Abhaya Libre;\n  color: #18316e;\n  font-size: 2rem;\n  margin-left: 1rem;\n}\n\n.title__content {\n  font-size: 1rem !important;\n  font-weight: 600;\n  text-align: left;\n  font-family: Inter;\n}\n\n.text__content {\n    margin-top: 1rem;\n    color: #18316e;\n    font-family: Inter;\n    font-weight: 400;\n}\n\n.container__campos{\n  margin-top: 1rem;\n  max-height: 30vh;\n  overflow: auto;\n}\n\n.container__buttons{\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 1rem;\n  width: 100%;\n}\n\n.form{\n  margin-top: 1rem;\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__y6519`,
	"header__responsivContent": `styles_header__responsivContent__PdP+W`,
	"content__responsivContent": `styles_content__responsivContent__YzOKE`,
	"icon__header": `styles_icon__header__nFZx-`,
	"title__header": `styles_title__header__1kkBV`,
	"title__content": `styles_title__content__EyjJH`,
	"text__content": `styles_text__content__o5qED`,
	"container__campos": `styles_container__campos__C4+tD`,
	"container__buttons": `styles_container__buttons__waFi8`,
	"form": `styles_form__O10P1`
};
export default ___CSS_LOADER_EXPORT___;
